package io.horion.cv.pages.cv

import com.varabyte.kobweb.compose.foundation.layout.Column
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaLaptopCode
import com.varabyte.kobweb.silk.components.icons.fa.FaMoon
import com.varabyte.kobweb.silk.components.icons.fa.FaSun
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.viewModel.CvViewModel
import io.horion.cv.api.datasource.cv.Model
import io.horion.cv.components.Footer
import io.horion.cv.components.Topbar
import io.horion.cv.di.koinGet
import io.horion.cv.models.CvData.cvList
import io.horion.cv.models.DomaineActivite.domaineList
import io.horion.cv.models.getDomaineIcon
import io.horion.cv.pages.job.company.FilterButton
import io.horion.cv.pages.navigation.Screen
import io.horion.cv.state.AppState
import io.horion.cv.styles.ChooseModelStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@OptIn(ExperimentalComposeWebApi::class, DelicateApi::class)
@Page("/domaine")
@Composable
fun DomaineActivity() {

    val ctx = rememberPageContext()
    val breakpoint = rememberBreakpoint()
    val isMobile = breakpoint <= Breakpoint.MD

    var page by remember { mutableStateOf(0) }

    val models = domaineList
    val totalPages = models.size
    val cardWidth = if (isMobile) 320 else 300
    val cardHeight = if (isMobile) 260 else 240
    val gap = if (isMobile) 12 else 20
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val pageBg = if (isDark) Colors.DarkBG else Colors.White
//    val textColor = if (isDark) Colors.White else Colors.Primary
    var selectedDomaine by remember { mutableStateOf<String?>(null) }
    var selectedExperience by remember { mutableStateOf<String?>(null) }


    val experiences = mapOf(
        "Junior" to "1 an",
        "MID" to "2 ans",
        "Senior" to "3 ans",
        "Expert" to "4 ans",
        "Plus" to "+ 5 ans"
    )
    Column (
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(pageBg)
            .styleModifier { property("transition", "background-color 300ms ease") }
    ){
//        HeaderDomaine(isMobile = isMobile)
        Topbar()
        if (isMobile) {
            Column(
                modifier = Modifier
                    .fillMaxSize()
                    .padding(top = 30.px, leftRight = 25.px),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                SpanText(
                    "Quel est votre domaine dactivite ?",
                    modifier = Modifier
//                        .color(textColor)
                        .fontSize(24.px)
                        .fontFamily(INTER)
                        .fontWeight(FontWeight.Bold)
                        .whiteSpace(WhiteSpace.PreWrap)
                        .padding(bottom = 10.px)
                        .styleModifier { property("text-align", "center") }
                )

                SpanText(
                    "Cliquez sur le domaine qui correspond\nà vos centres d'intérêts pour continuer",
                    modifier = Modifier
//                        .color(textColor)
                        .fontSize(13.px)
                        .fontFamily(INTER)
                        .fontWeight(FontWeight.Light)
                        .whiteSpace(WhiteSpace.PreWrap)
                        .margin(bottom = 25.px)
                        .styleModifier { property("text-align", "center") }
                )

                Box(
                    modifier = Modifier
                        .width(cardWidth.px)
                        .height((cardHeight+30).px)
                        .position(Position.Relative)
                        .styleModifier { overflow(Overflow.Hidden) }
                ) {
                    Row(
                        modifier = Modifier
                            .height(cardHeight.px)
                            .width(((cardWidth + gap) * domaineList.size).px)
                            .styleModifier {
                                property("transform", "translateX(-${page * (cardWidth + gap)}px)")
                                property("transition", "transform 400ms ease")
                            }
                    ) {
                        domaineList.forEach { model ->
                            Box(
                                modifier = Modifier
                                    .width(cardWidth.px)
                                    .height(cardHeight.px)
                                    .margin(right = gap.px)
                            ) {
                                DomaineCard(
                                    title = model.key,
                                    description = model.value,
                                    icon = getDomaineIcon(domaine = model.key),
                                    isSelected = selectedDomaine == model.key,
                                    onClick = {  selectedDomaine = if (selectedDomaine == model.key) null else model.key
                                        selectedExperience = null}
                                )
                            }
                        }
                    }

                    if (page > 0) {
                        ChevronButtons(left = true) { page-- }
                    }
                    ChevronButtons(left = false) {
                        page = (page + 1) % totalPages
                    }
                }
                if (selectedDomaine != null) {

                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .margin(top = 30.px)
                            .padding(20.px)
                            .backgroundColor(
                                if (isDark) Colors.Primary else Colors.White
                            )
                            .borderRadius(16.px)
                            .styleModifier {
                                property(
                                    "box-shadow",
                                    "0px 2px 10px rgba(0,0,0,0.08)"
                                )
                            }
                    ) {

                        Column {

                            SpanText(
                                text = "Votre niveau d'expérience en ${selectedDomaine}",
                                modifier = Modifier
                                    .fontSize(18.px)
                                    .fontWeight(FontWeight.Bold)
                                    .margin(bottom = 20.px)
                            )

                            Row(
                                modifier = Modifier.fillMaxWidth(),
                                horizontalArrangement = Arrangement.spacedBy(12.px)
                            ) {

                                experiences.forEach { exp ->

                                    FilterButton(
                                        label = exp.value,
                                        isSelected = selectedExperience == exp.key,
                                        onClick = {
                                            selectedExperience = exp.key
                                        },
                                        color = Colors.secondary
                                    )
                                }
                            }
                        }
                    }
                }
                if (selectedDomaine != null && selectedExperience != null) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(top = 20.px, bottom = 30.px),
                        contentAlignment = Alignment.Center
                    ) {
                        Box(
                            modifier = Modifier
                                .padding(leftRight = 40.px, topBottom = 14.px)
                                .backgroundColor(Colors.secondary)
                                .borderRadius(12.px)
                                .cursor(Cursor.Pointer)
                                .styleModifier {
                                    property("transition", "opacity 300ms ease")
                                }
                                .onClick {
                                    ctx.router.navigateTo(Screen.Motivation.path)
                                }
                        ) {
                            SpanText(
                                "Continuer",
                                modifier = Modifier
                                    .fontSize(16.px)
                                    .fontWeight(FontWeight.Bold)
                                    .fontFamily(INTER)
                            )
                        }
                    }
                }
            }
        } else {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .backgroundColor(pageBg)
            ) {
                // ─── Bloc 1 : Choisir le domaine ───
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(top = 30.px, right = 700.px, bottom = 15.px)
                ) {
                    Row(
                        modifier = Modifier.fillMaxSize(),
                        horizontalArrangement = Arrangement.End,
                        verticalAlignment = Alignment.Top
                    ) {
                        Column(
                            modifier = Modifier
                                .fillMaxHeight()
                        ) {

                            Box(Modifier.height(130.px))

                            SpanText(
                                "Choisissez\nVotre domaine",
                                modifier = Modifier
                                    .fontSize(36.px)
                                    .fontFamily(INTER)
                                    .fontWeight(FontWeight.Bold)
                                    .whiteSpace(WhiteSpace.PreWrap)
                            )

                            Box(Modifier.height(10.px))

                            SpanText(
                                "Cliquez sur le domaine qui correspond\nà vos centres d'intérêts pour continuer",
                                modifier = Modifier
                                    .fontSize(16.px)
                                    .fontFamily(INTER)
                                    .fontWeight(FontWeight.Light)
                                    .whiteSpace(WhiteSpace.PreWrap)
                            )
                            Box(Modifier.height(30.px))
                        }
                        Box(modifier = Modifier.width(120.px))

                        Box(
                            modifier = Modifier
                                .width(cardWidth.px)
                                .height((cardHeight + 30).px)
                                .position(Position.Relative)
                                .styleModifier {
                                    overflow(Overflow.Hidden)
                                },
                        ) {

                            Row(
                                modifier = Modifier
                                    .height(cardHeight.px)
                                    .width(((cardWidth + gap) * domaineList.size).px)
                                    .styleModifier {
                                        property(
                                            "transform",
                                            "translateX(-${page * (cardWidth + gap)}px)"
                                        )
                                        property("transition", "transform 400ms ease")
                                    }
                            ) {
                                domaineList.forEach { model ->
                                    Box(
                                        modifier = Modifier
                                            .width(cardWidth.px)
                                            .height(cardHeight.px)
                                            .margin(right = gap.px)
                                    ) {

                                        DomaineCard(
                                            title = model.key,
                                            description = model.value,
                                            icon =
                                                getDomaineIcon(domaine = model.key),
                                            isSelected = selectedDomaine == model.key,
                                            onClick = { selectedDomaine = if (selectedDomaine == model.key) null else model.key
                                                selectedExperience = null}
                                        )
                                    }
                                }
                            }

                            if (page > 0) {
                                ChevronButtons(left = true) {
                                    page--
                                }
                            }

                            ChevronButtons(left = false) {
                                page = (page + 1) % totalPages
                            }
                        }
                    }
                }
                if (selectedDomaine != null) {

                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .margin(top = 30.px)
                            .padding(30.px)
                            .backgroundColor(
                                if (isDark) Colors.Primary else Colors.White
                            )
                            .borderRadius(18.px)
                            .styleModifier {
                                property(
                                    "box-shadow",
                                    "0px 4px 20px rgba(0,0,0,0.08)"
                                )
                            },
                        contentAlignment = Alignment.Center
                    ) {

                        Column {

                            SpanText(
                                text = "Votre niveau d'expérience en ${selectedDomaine}",
                                modifier = Modifier
                                    .fontSize(22.px)
                                    .fontWeight(FontWeight.Bold)
                                    .margin(bottom = 25.px)
                            )

                            Row(
                                modifier = Modifier.fillMaxWidth(),
                                horizontalArrangement = Arrangement.spacedBy(16.px)
                            ) {

                                experiences.forEach { exp ->

                                    FilterButton(
                                        label = exp.value,
                                        isSelected = selectedExperience == exp.key,
                                        onClick = {
                                            selectedExperience = exp.key
                                        }
                                    )
                                }
                            }
                        }
                    }
                }
                if (selectedDomaine != null && selectedExperience != null) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(top = 20.px, bottom = 30.px),
                        contentAlignment = Alignment.Center
                    ) {
                        Box(
                            modifier = Modifier
                                .padding(leftRight = 40.px, topBottom = 14.px)
                                .backgroundColor(Colors.secondary)
                                .borderRadius(12.px)
                                .cursor(Cursor.Pointer)
                                .styleModifier {
                                    property("transition", "opacity 300ms ease")
                                }
                                .onClick {
                                    ctx.router.navigateTo(Screen.Motivation.path)
                                }
                        ) {
                            SpanText(
                                "Continuer",
                                modifier = Modifier
//                                    .color(Colors.White)
                                    .fontSize(16.px)
                                    .fontWeight(FontWeight.Bold)
                                    .fontFamily(INTER)
                            )
                        }
                    }
                }
            }
        }
    }
}

@Composable
fun HeaderDomaine(
    isMobile: Boolean = false
) {
    var colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val headerBg      = if (isDark) Colors.DarkBG   else Colors.White
    val borderColor   = if (isDark) Colors.DarkGray else Colors.LightGray
    val textColor     = if (isDark) Colors.White     else Colors.Primary
    val iconFilter    = if (isDark) "none"           else "invert(1)"

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .backgroundColor(headerBg)
            .styleModifier { property("transition", "background-color 300ms ease") }
            .padding(if (isMobile) 16.px else 20.px)
            .borderBottom(1.px, LineStyle.Solid, borderColor)
            .textDecorationLine(TextDecorationLine.None),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        Link(
            path = "/",
            modifier = Modifier.textDecorationLine(TextDecorationLine.None)
        ) {
            Row(
                modifier = Modifier
                    .cursor(Cursor.Pointer)
                    .margin(left = if (isMobile) 10.px else 90.px),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Image(
                    src = "home.svg",
                    modifier = Modifier.size(if (isMobile) 18.px else 24.px)
                        .styleModifier {
                            property("filter", iconFilter)
                        }
                )
                SpanText(
                    "Accueil",
                    modifier = Modifier
                        .margin(left = 10.px)
                        .fontFamily(INTER)
                        .fontSize(if (isMobile) 12.px else 16.px)
                        .color(textColor)
                )
            }
        }

        Spacer()

        Row(
            modifier = Modifier
                .margin(right = if (isMobile) 30.px else 800.px),
            verticalAlignment = Alignment.CenterVertically
        ) {

            Image(
                "cloud-check.svg",
                modifier = Modifier.size(if (isMobile) 18.px else 24.px)
                    .styleModifier {
                        property("filter", iconFilter)
                    }
            )
        }
        Row(
            modifier = Modifier.margin(right = if (isMobile) 10.px else 90.px),
            verticalAlignment = Alignment.CenterVertically
        ) {
            if (isDark) {
                FaSun(
                    modifier = Modifier
                        .fontSize(if (isMobile) 18.px else 25.px)
                        .color(Colors.yellow)
                        .cursor(Cursor.Pointer)
                        .onClick { colorMode = colorMode.opposite }
                )
            } else {
                FaMoon(
                    modifier = Modifier
                        .fontSize(if (isMobile) 18.px else 25.px)
                        .color(Colors.Primary)
                        .cursor(Cursor.Pointer)
                        .onClick { colorMode = colorMode.opposite }
                )
            }
        }
    }
}
@Composable
fun DomaineCard(
    title: String,
    description: String,
    icon: @Composable () -> Unit,
    isSelected: Boolean = false,
    isMobile: Boolean = false,
    onClick: () -> Unit
) {

    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    Box(
        modifier = ChooseModelStyle.toModifier()
            .width(if (isMobile) 320.px else 300.px)
            .height(if (isMobile) 260.px else 240.px)
            .padding(20.px)
            .cursor(Cursor.Pointer)
            .backgroundColor(
                if (isSelected) {
                    Colors.secondary
                } else {
                    if (isDark) Colors.Primary else Colors.White
                }
            )
            .border(
                2.px,
                LineStyle.Solid,
                if (isSelected) Colors.Blue else Colors.LightGray
            )
            .borderRadius(16.px)
            .styleModifier {
                property(
                    "filter",
                    if (isDark)
                        "none"
                    else
                        "drop-shadow(0px 2px 10px rgba(0,0,0,0.12))"
                )

                property("transition", "all 300ms ease")
            }
            .onClick { onClick() }
    ) {

        Column(
            modifier = Modifier.fillMaxSize(),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.Center
        ) {

            // Cadre de l'icone
            Box(
                modifier = Modifier
                    .size(if (isMobile) 90.px else 100.px)
                    .backgroundColor(
                        if (isDark)
                            Colors.gray
                        else
                            Colors.LightGray
                    )
                    .borderRadius(16.px),
                contentAlignment = Alignment.Center
            ) {
                icon()
            }

            // Nom du domaine
            SpanText(
                text = title,
                modifier = Modifier
                    .margin(top = 18.px)
                    .fontSize(if (isMobile) 18.px else 20.px)
                    .fontWeight(FontWeight.Bold)
                    .color(if (isDark) Colors.White else Colors.Black)
            )

            // Description légère
            SpanText(
                text = description,
                modifier = Modifier
                    .margin(top = 10.px)
                    .fontSize(if (isMobile) 13.px else 14.px)
                    .color(if (isDark) Colors.LightGray else Colors.Graytext),
            )
        }
    }
}